import React, {PureComponent, Fragment} from 'react';
import styled, {keyframes} from 'styled-components';
import {isSafari, isWX, isAndroid} from '../../tools';
import {DOWNLOAD, UNIVERSAL_LINKS} from '../../constants';
import logo from './images/logo.png';
import bg from './images/bg.png';
import icon from './images/icon.svg';
import wxTips from './images/wx-tips.png';

const Wrap = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  background-image: linear-gradient(rgba(255,255,255,.09) 74%,rgba(133,83,242,0.3) 100%);
`;

const DownMain = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 83%;
`;

const DownLogo = styled.div`
  display: block;
  width: 70px;
  height: 70px;
  background-image: url(${logo});
  background-size: contain;
`;

const Slogan = styled.p`
  margin-top: 28px;
  font-size: 20px;
  color: #777;
`;

const DownBtn = styled.div`
  display: block;
  width: 270px;
  line-height: 40px;
  border-radius: 3px;
  font-size: 18px;
  text-align: center;
  background-image: linear-gradient(#ef3e82,#8553f2);
  margin-top: 28px;
  color: #fff;
  font-weight: bold;
  transition: .3s;
  cursor: pointer;
  &:active{
    opacity: .5;
  }
`;

const WX = styled.div`
  display: ${isWX() ? 'block' : 'none'};
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  > img {
    display: block;
    border: none;
    width: 100%;
    height: auto;
  }
`;

const FootDown = styled.div`
  display: flex;
  position: absolute;
  z-index: 1;
  bottom: 50px;
  left: 0;
  right: 0;
  max-width: 340px;
  margin: auto;
  box-sizing: border-box;
  padding: 15px 0;
  background-color: rgba(246,246,246,0.97);
  align-items: center;
  justify-content: space-around;
  border-radius: 3px;
  box-shadow: 0 -0.5px 4px 0 rgba(68,68,68,.15);
  > img{
     display: block;
     width: 42px;
     height: 42px;
     flex: none;
  }
  > div {
    p{
      margin: 0;
    }
    p:first-of-type{
      font-size: 14px;
      color: #444;
    }
    p:last-of-type{
      font-size: 12px;
      color: #999;
    }
  }
  > span {
    padding: 8px 16px;
    color: #fff;
    font-size: 14px;
    border-radius: 6px;
    background-image: linear-gradient(#ef3e82,#8553f2);
    cursor: pointer;
  }
`;

const Footer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
`;

const FooterImg = styled.div`
  background-image: url(${bg});
  background-size: cover;
  bottom: -44px;
  height: 192px;
  left: 50%;
  margin-left: -145px;
  position: fixed;
  width: 290px;
`;

const SafariTips = styled.div`
  position: fixed;
  display: ${isSafari() ? 'flex' : 'none'};
  justify-content: center;
  align-items: center;
  width: 100%;
  text-align: center;
  color: #777;
  font-size: 18px;
  height: 60px;
`;

const arrowAni = keyframes`
  0%{ 
    transform: translateY(-5px);
    opacity: 0;
  }
  
  50% {
    transform: translateY(0);
    opacity: 1;
  }
  100% {
    transform: translateY(5px);
    opacity: 0;
  }
`;

const Arrow = styled.span`
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-left: 12px;
  background: url(${icon});
  background-size: 16px 16px;
  animation: ${arrowAni} 1s infinite linear;
`;

function goYYB() {
  window.location.href = DOWNLOAD.yyb;
}

class UpApp extends PureComponent {
  render() {
    console.log('这个界面只能说对不起知乎了');

    // 安卓微信自动打开
    if (isAndroid() && isWX()) {
      goYYB();
    }

    return (
      <Fragment>
        <Wrap>
          <SafariTips>已下载？下拉打开应用<Arrow/></SafariTips>
          <DownMain>
            <DownLogo/>
            <Slogan>潮流生活短视频分享社区</Slogan>
            <DownBtn onClick={goYYB}>立即下载</DownBtn>
          </DownMain>
          <WX>
            <img src={wxTips} alt="bg"/>
            <FootDown>
              <img src={logo} alt="logo"/>
              <div>
                <p>下载「UP短视频」客户端</p>
                <p>潮流生活短视频分享社区</p>
              </div>
              <span onClick={goYYB}>立即前往</span>
            </FootDown>
          </WX>
          <Footer>
            <FooterImg/>
          </Footer>
        </Wrap>
      </Fragment>
    );
  }
}

const {hostname} = window.location;
const checkWidthUpApp = Comp => (hostname === UNIVERSAL_LINKS) ? UpApp : Comp;

export {checkWidthUpApp};


// WEBPACK FOOTER //
// ./src/containers/UpApp/index.jsx